import { render, staticRenderFns } from "./ValoresPersonalizados.vue?vue&type=template&id=b724b8ce&scoped=true"
import script from "./ValoresPersonalizados.vue?vue&type=script&lang=js"
export * from "./ValoresPersonalizados.vue?vue&type=script&lang=js"
import style0 from "./ValoresPersonalizados.vue?vue&type=style&index=0&id=b724b8ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b724b8ce",
  null
  
)

export default component.exports